import { render, staticRenderFns } from "./employees-table.vue?vue&type=template&id=7a8b7968&"
import script from "./employees-table.vue?vue&type=script&lang=js&"
export * from "./employees-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports